import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../../context/LanguageContext';

const partners = [
  {
    id: 'basf',
    name: 'BASF — We create chemistry',
    logo: 'https://customer-assets.emergentagent.com/job_f79f1573-be7d-47b7-99e2-70d1f8759bc8/artifacts/b3z3260d_BASF.png',
  },
  {
    id: 'kenoma',
    name: 'KENOMA — Providing more than enough',
    logo: 'https://customer-assets.emergentagent.com/job_f79f1573-be7d-47b7-99e2-70d1f8759bc8/artifacts/gfypjz6l_KENOMA.png',
  },
];

const PartnersSection = () => {
  const { t, isRTL } = useLanguage();

  return (
    <section
      className="py-24 bg-white"
      dir={isRTL ? 'rtl' : 'ltr'}
      data-testid="partners-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-14"
        >
          <p className="text-[#9B4B8C] text-sm font-medium uppercase tracking-wider mb-3">
            {t.partners.eyebrow}
          </p>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            {t.partners.title}
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto leading-relaxed">
            {t.partners.description}
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {partners.map((partner, index) => (
            <motion.div
              key={partner.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="group relative overflow-hidden rounded-2xl bg-gray-50 hover:bg-gray-100 transition-colors shadow-md hover:shadow-xl"
              data-testid={`partner-card-${partner.id}`}
            >
              <div className="aspect-[4/3] flex items-center justify-center p-6">
                <img
                  src={partner.logo}
                  alt={partner.name}
                  className="w-full h-full object-contain transform group-hover:scale-105 transition-transform duration-500"
                />
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;
